module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-09-684de0faac9e2ec8b2559c9a2da1d595.png";